import React from 'react';
import EmployeeNoteItem from 'components/common/employeeNoteItem';
import { NoteItem } from 'interface/note';

interface EmployeeNoteListEntry {
  note: NoteItem;
  showHeader?: boolean;
  compact?: boolean;
  isOpen?: boolean;
}

interface EmployeeNoteListProps {
  notes: EmployeeNoteListEntry[];
  authUserId: number;
}

const EmployeeNoteList: React.FC<EmployeeNoteListProps> = (props) => {
  const { notes, authUserId } = props;

  return (
    <>
      {notes.map(({ note, showHeader, compact, isOpen }, idx) => (
        <EmployeeNoteItem
          index={idx + 1}
          key={idx + 1}
          note={note}
          showHeader={showHeader}
          compact={compact}
          isOpen={isOpen}
          authUserId={authUserId}
        />
      ))}
    </>
  );
};

export default EmployeeNoteList;
